import { render, staticRenderFns } from "./RespondidasSelo.vue?vue&type=template&id=7108d5b5&scoped=true"
import script from "./RespondidasSelo.vue?vue&type=script&lang=js"
export * from "./RespondidasSelo.vue?vue&type=script&lang=js"
import style0 from "./RespondidasSelo.vue?vue&type=style&index=0&id=7108d5b5&prod&lang=css"
import style1 from "./RespondidasSelo.vue?vue&type=style&index=1&id=7108d5b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7108d5b5",
  null
  
)

export default component.exports